import React from 'react';
import aboutImage from '../assets/images/front.jpeg';
// Import client logos
import asasLogo from '../assets/clients/asas.png';
import transfuelLogo from '../assets/clients/transfuel.png';
import lakeOilLogo from '../assets/clients/lakeoil.png';
import jtEnergyLogo from '../assets/clients/jtenergy.png';
import hassLogo from '../assets/clients/hass.png';
import oilcomLogo from '../assets/clients/oilcom.png';
import oryxLogo from '../assets/clients/oryx.png';

const AboutUs = () => {
  const clients = [
    { name: 'ASAS', logo: asasLogo },
    { name: 'TRANSFUEL', logo: transfuelLogo },
    { name: 'LAKE OIL', logo: lakeOilLogo },
    { name: 'JT ENERGY', logo: jtEnergyLogo },
    { name: 'OILCOM', logo: oilcomLogo },
    { name: 'HASS PETROLEUM', logo: hassLogo },
    { name: 'ORYX', logo: oryxLogo },
  ];

  const CoreValueCard = ({ title, description }) => (
    <div className="col-md-4 mb-4">
      <div className="value-card">
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
    </div>
  );

  const ServiceCard = ({ title, description }) => (
    <div className="service-card mb-4">
      <h5>{title}</h5>
      <p>{description}</p>
    </div>
  );

  return (
    <div className="about_section layout_padding">
      <div className="container">
        {/* Story Section */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <div className="detail-box">
              <div className="heading_container">
                <h2>Our <span>Story</span></h2>
              </div>
              <p>
                Founded with a vision to redefine fuel logistics in Tanzania and beyond, MK AVANCO COMPANY LTD emerged as a trusted partner in the region's energy supply chain. The journey began with a single goal — to provide reliable and safe fuel transportation amidst complex regional logistics challenges.
              </p>
              <p>
                Through resilience, innovation, and a deep understanding of local dynamics, we grew into a premier provider, bridging energy needs across East and Central Africa. From our humble beginnings, we have built a reputation for operational excellence, trust, and a commitment to sustainability, making us the partner of choice for industries and governments alike.
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="img-box">
              <img src={aboutImage} alt="MK Avanco Office" className="img-fluid rounded shadow" />
            </div>
          </div>
        </div>

        {/* Mission & Vision */}
        <div className="row mt-5">
          <div className="col-md-6 mb-4">
            <div className="mission-box p-4 h-100 bg-light rounded shadow-sm">
              <div className="heading_container">
                <h3>Mission Statement</h3>
              </div>
              <p>To bridge local and regional energy gaps by providing seamless, safe, and sustainable fuel transportation solutions tailored to the unique needs of East and Central Africa.</p>
            </div>
          </div>
          <div className="col-md-6 mb-4">
            <div className="vision-box p-4 h-100 bg-light rounded shadow-sm">
              <div className="heading_container">
                <h3>Vision Statement</h3>
              </div>
              <p>To be the preferred fuel logistics partner, recognized for innovative solutions that address local challenges while driving energy security and sustainable growth.</p>
            </div>
          </div>
        </div>

        {/* Services Section */}
        <div className="row mt-5">
          <div className="col-12">
            <div className="heading_container">
              <h2>Our <span>Services</span></h2>
            </div>
            <div className="services-box p-4 bg-light rounded shadow-sm">
              <div className="row">
                <div className="col-md-6">
                  <ul className="service-list">
                    <li>
                      <h5>Cross-Border Fuel Transportation</h5>
                      <p>Secure haulage of petrol, diesel, jet fuel, and lubricants tailored to regional needs.</p>
                    </li>
                    <li>
                      <h5>Customs and Regulatory Compliance</h5>
                      <p>Expertise in managing cross-border documentation and trade regulations.</p>
                    </li>
                    <li>
                      <h5>Fleet Solutions</h5>
                      <p>Modern, ADR-certified tankers equipped with advanced safety and monitoring systems.</p>
                    </li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <ul className="service-list">
                    <li>
                      <h5>Risk Management</h5>
                      <p>24/7 emergency response and real-time cargo tracking.</p>
                    </li>
                    <li>
                      <h5>Consultancy Services</h5>
                      <p>Advisory support on fuel logistics, compliance, and operational efficiency.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Safety and Compliance */}
        <div className="row mt-5">
          <div className="col-12">
            <div className="heading_container">
              <h2>Safety & <span>Compliance</span></h2>
            </div>
            <div className="safety-box p-4 bg-light rounded shadow-sm text-center">
              <div className="row justify-content-center">
                <div className="col-md-8">
                  <h4>Safety Practices</h4>
                  <ul className="list-unstyled">
                    <li>Regular fleet maintenance</li>
                    <li>Adherence to EWURA standards</li>
                    <li>Proactive environmental protection measures</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Community Commitment */}
        <div className="row mt-5">
          <div className="col-12">
            <div className="heading_container">
              <h2>Community <span>Commitment</span></h2>
            </div>
            <div className="community-box p-4 bg-light rounded shadow-sm">
              <div className="row">
                <div className="col-md-4 mb-3">
                  <h5>Local Development</h5>
                  <p>Supporting educational and healthcare initiatives along transport corridors.</p>
                </div>
                <div className="col-md-4 mb-3">
                  <h5>Road Safety Campaigns</h5>
                  <p>Collaborating with authorities to promote safe driving.</p>
                </div>
                <div className="col-md-4 mb-3">
                  <h5>Environmental Protection</h5>
                  <p>Reforestation projects and clean energy advocacy.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

       {/* Clients Section with Enhanced Cards */}
       <div className="section-container mb-5">
          <div className="heading_container">
            <h2>Our <span>Clients</span></h2>
          </div>
          <div className="row">
            {clients.map((client, index) => (
              <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-4">
                <div className="client-card">
                  <div className="client-card-inner">
                    <div className="logo-container">
                      <img 
                        src={client.logo} 
                        alt={`${client.name} logo`} 
                        className="client-logo"
                      />
                    </div>
                    <div className="client-info">
                      <h5>{client.name}</h5>
                      <div className="card-overlay">
                        <span className="trusted-partner">Trusted Partner</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Contact Section */}
        <div className="row mt-5">
          <div className="col-12">
            <div className="contact-info text-center">
              <div className="heading_container justify-content-center">
                <h2>Contact <span>Information</span></h2>
              </div>
              <div className="mt-4">
                <p><strong>Address:</strong> 10th Floor, Mwanga Tower, Alongside New Bagamoyo Road, Dar es Salaam, Tanzania</p>
                <p><strong>Phone:</strong> +255 717 039 523 </p>
                <p><strong>Email:</strong> info@mkavanco.co.tz</p>
                <p><strong>Website:</strong> www.mkavanco.co.tz</p>
              </div>
              <div className="mt-4 motto">
                <h4>"TEAM WORK MAKES THE DREAM WORK"</h4>
                <p>MK AVANCO COMPANY LIMITED</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;